import { parseStringIntoFormattedStringDate } from 'utils/parsers/dateTime/parseStringIntoFormattedStringDate';

type DateDisplayProps = {
    date: string;
};

export const DateDisplay = ({ date }: DateDisplayProps) => parseStringIntoFormattedStringDate(date);
